import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { ModalContext, RecurringSpaceBookingsTable } from 'school-space-client/components';

import { openRecurringSpaceBookingModal, openSpaceCancellationModal } from './modals';

const RecurringBookingSpaces = ({ recurringBooking, refetchBooking, spacesAreEditable }) => {
    const modalProps = useContext(ModalContext);

    const updateSpace = space =>
        openRecurringSpaceBookingModal({
            ...modalProps,
            recurringBooking,
            refetchBooking,
            originalRecurringSpaceBooking: space
        });

    const cancelSpace = ({ id }) =>
        openSpaceCancellationModal({
            ...modalProps,
            recurringBooking,
            refetchBooking,
            recurringSpaceBookingId: id
        });

    return (
        <section>
            <RecurringSpaceBookingsTable
                spaceBookings={recurringBooking.spaces}
                {...(spacesAreEditable && { updateSpace, cancelSpace })}
            />
        </section>
    );
};

RecurringBookingSpaces.propTypes = {
    recurringBooking: PropTypes.objectOf(PropTypes.any).isRequired,
    refetchBooking: PropTypes.func.isRequired,
    spacesAreEditable: PropTypes.bool.isRequired
};

export default RecurringBookingSpaces;
